import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Observer} from 'rxjs/Observer';


export interface TitleInfo {
    title: string;
    params: Object;
}

@Injectable()
export class TitleService {

    private observer = null;
    private obs: Observable<TitleInfo> = null;

    constructor() {
        this.obs = Observable.create((observer) => {
            this.observer = observer;
        });
    }

    public get title(): Observable<TitleInfo> {
        return this.obs;
    }


    public setTitle(titleObj: string | TitleInfo) {
        if (this.observer !== null) {
            if (typeof  titleObj === 'string') {
                this.observer.next({title: titleObj, params: {}});
            } else {
                this.observer.next(titleObj);
            }
        } else {
            this.obs = Observable.create((observer) => {
                this.observer = observer;

                if (typeof  titleObj === 'string') {
                    this.observer.next({title: titleObj, params: {}});
                } else {
                    this.observer.next(titleObj);
                }
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/services/title.service.ts